"use client"

import CrossIcon from "@/Components/Common/Icons/CrossIcon";
import EmailIcon from "@/Components/website/common/Icons/EmailIcon";
import LockIconOutline from "@/Components/website/common/Icons/LockIconOutline";
import { useUserSigninMutation } from "@/Redux/apis/auth";
import { userData } from "@/Redux/apis/userData";
import Cookies from "js-cookie";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { savePendingSignIn } from "@/utils/twoFactorPending";

const LoginPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false)
  const [userSiginApi, signinResponse] = useUserSigninMutation();
  const router = useRouter();
  const pathname = usePathname();
  const dispatch = useDispatch();
  useEffect(() => {
    handleResponse()
  }, [signinResponse])

  const handleResponse = async () => {
    if (signinResponse.isLoading) {
      setLoading(true)
    } else if (signinResponse.isError) {
      setLoading(false)
      toast.error(signinResponse.error)
    } else if (signinResponse.isSuccess) {
      setLoading(false);
      const signedIn = signinResponse?.data?.user;
      // Two-factor accounts must enter the emailed code before they are
      // logged in — this popup used to log them straight in.
      if (signedIn?.twoFactorPending) {
        Cookies.remove("token");
        Cookies.remove("isReps");
        savePendingSignIn({ pendingToken: signedIn.pendingToken, email: signedIn.email, account: "user" });
        onClose();
        router.push(`/provider/two-factor-verification?redirect=${encodeURIComponent(pathname)}`);
        toast.success("Verification OTP sent successfully");
        return;
      }
      const data = { token: signinResponse?.data?.user?.token };
      await dispatch(userData(data)); // Wait for userData to be updated
      setLoading(false);
      
      Cookies.set("token", signinResponse?.data?.user?.token);
      Cookies.set("isReps", signinResponse?.data?.user?.reps);
      onClose();
      // window.location.reload();
      router.refresh()
    }
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    if (email && password) {
      const authPayload = {
        email: email,
        password: password,
      }
      await userSiginApi(authPayload);
    }
  }
  return (
    <>
      <div className="fixed inset-0 popup-bg z-40 flex justify-center items-center">
        <div className="w-[440px] h-[386px] p-6 bg-white rounded-2xl shadow border border-neutral-200 flex-col justify-start items-start gap-2.5 inline-flex">
          <div className="flex justify-between items-center pb-3 border-b border-[#E1E1E1] w-full">
            <div className="text-[16px] font-semibold text-black">
              Login to your account
            </div>
            <div className=" cursor-pointer" onClick={onClose}>
              <CrossIcon />
            </div>
          </div>
          <form onSubmit={handleLogin} className=" space-y-4 w-full">
            <div className="w-full">
              <div className="text-[14px] font-medium text-[#8E8E8E]">Email</div>
              <div className="border flex items-center w-full mt-2 rounded-lg p-2  border-[#CACACA]">
                <div>
                  <EmailIcon />
                </div>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  required
                  placeholder="Someone@example.com"
                  className="w-full rounded-lg border-none outline-none px-2"
                />
              </div>
            </div>
            <div className="w-full">
              <div className="text-[14px] font-medium text-[#8E8E8E]">Password</div>
              <div className="border flex items-center w-full mt-2 rounded-lg p-2  border-[#CACACA]">
                <div>
                  <LockIconOutline />
                </div>
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  required
                  placeholder="Enter your password"
                  className="w-full rounded-lg border-none outline-none px-2"
                />
              </div>
            </div>
            <div className="flex justify-end underline text-[14px] font-medium text-[#354EF0] cursor-pointer">
              Forgot Password?
            </div>
            <button disabled={email.length == 0 && password.length == 0} type="submit" className="text-[16px] font-medium bg-[#354EF0] disabled:bg-[#8E8E8E] text-white rounded-lg py-3 w-full">{loading ? "Logging in..." : "Log In"}</button>
            <div className="text-[14px] text-center font-medium text-[#8E8E8E]">
              Don't have an account? <span className=" underline text-[14px] font-medium cursor-pointer text-[#354EF0]">Create Account</span>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginPopup;
